// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/route.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/route.proto.
 */
export const file_transportation_v1_route: GenFile = /*@__PURE__*/
  fileDesc("Ch10cmFuc3BvcnRhdGlvbi92MS9yb3V0ZS5wcm90bxIRdHJhbnNwb3J0YXRpb24udjEiqwUKBVJvdXRlEhUKAmlkGAEgASgLMgkudHlwZXMuSUQSFwoPZG9jdW1lbnRfbnVtYmVyGAIgASgJEi4KBnN0YXR1cxgDIAEoDjIeLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlU3RhdHVzEhkKEWFzc2lnbm1lbnRfc3RhdHVzGAQgASgJEhcKD2RyaXZlcl9wcm9ncmVzcxgFIAEoCRIXCg9oYXVsZXJfcHJvZ3Jlc3MYBiABKAkSDAoEcmFuaxgHIAEoCRIQCghwcmlvcml0eRgIIAEoBRIuCgpyb3V0ZV9kYXRlGAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgpzdGFydGVkX2F0GAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIwCgxjb21wbGV0ZWRfYXQYCyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhMKC2Rlc2NyaXB0aW9uGAwgASgJEg0KBW5vdGVzGA0gASgJEiQKEWZhY2lsaXR5X2dyb3VwX2lkGA4gASgLMgkudHlwZXMuSUQSHAoJZHJpdmVyX2lkGA8gASgLMgkudHlwZXMuSUQSHAoJaGF1bGVyX2lkGBAgASgLMgkudHlwZXMuSUQSGwoIdHJ1Y2tfaWQYESABKAsyCS50eXBlcy5JRBIdCgp0cmFpbGVyX2lkGBIgASgLMgkudHlwZXMuSUQSLwoLYXNzaWduZWRfYXQYEyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjUKEWVzdGltYXRlZF9hcnJpdmFsGBQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIZCgRiYXNlGBUgASgLMgsudHlwZXMuQmFzZSJKCghSb3V0ZUxlZxINCgVzdGFydBgBIAEoCRILCgNlbmQYAiABKAkSEAoIZGlzdGFuY2UYAyABKAESEAoIZHVyYXRpb24YBCABKAUiQQoUUm91dGVUcmFuc2l0aW9uSW5wdXQSCgoCaWQYASABKAkSDgoGc3RhdHVzGAIgASgJEg0KBW5vdGVzGAMgASgJIqABChBSb3V0ZUFzc2lnbklucHV0EgoKAmlkGAEgASgJEhkKEWFzc2lnbm1lbnRfc3RhdHVzGAIgASgJEhEKCWRyaXZlcl9pZBgDIAEoCRIRCgloYXVsZXJfaWQYBCABKAkSEAoIdHJ1Y2tfaWQYBSABKAkSEgoKdHJhaWxlcl9pZBgGIAEoCRIZChFlc3RpbWF0ZWRfYXJyaXZhbBgHIAEoCSJMCg9HZXRSb3V0ZVJlcXVlc3QSFQoCaWQYASABKAsyCS50eXBlcy5JRBIiCg9vcmdhbml6YXRpb25faWQYAiABKAsyCS50eXBlcy5JRCI7ChBHZXRSb3V0ZVJlc3BvbnNlEicKBXJvdXRlGAEgASgLMhgudHJhbnNwb3J0YXRpb24udjEuUm91dGUinAEKEUxpc3RSb3V0ZXNSZXF1ZXN0EjMKBmZpbHRlchgBIAEoCzIjLnRyYW5zcG9ydGF0aW9uLnYxLkxpc3RSb3V0ZXNGaWx0ZXISMwoHc29ydGluZxgCIAMoDjIiLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlU29ydE9wdGlvbhIOCgZvZmZzZXQYAyABKAUSDQoFbGltaXQYBCABKAUizQIKEExpc3RSb3V0ZXNGaWx0ZXISFgoDaWRzGAEgAygLMgkudHlwZXMuSUQSLgoGc3RhdHVzGAIgASgOMh4udHJhbnNwb3J0YXRpb24udjEuUm91dGVTdGF0dXMSMQoLc2VhcmNoX3Rlcm0YAyABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSIgoPb3JnYW5pemF0aW9uX2lkGAQgASgLMgkudHlwZXMuSUQSHQoKZHJpdmVyX2lkcxgFIAMoCzIJLnR5cGVzLklEEh0KCmhhdWxlcl9pZHMYBiADKAsyCS50eXBlcy5JRBIcCgl0cnVja19pZHMYByADKAsyCS50eXBlcy5JRBIeCgt0cmFpbGVyX2lkcxgIIAMoCzIJLnR5cGVzLklEEh4KC3NlcnZpY2VfaWRzGAkgAygLMgkudHlwZXMuSUQiTQoSTGlzdFJvdXRlc1Jlc3BvbnNlEigKBnJvdXRlcxgBIAMoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlEg0KBXRvdGFsGAIgASgFImYKEkNyZWF0ZVJvdXRlUmVxdWVzdBIsCgVpbnB1dBgBIAEoCzIdLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlSW5wdXQSIgoPb3JnYW5pemF0aW9uX2lkGAIgASgLMgkudHlwZXMuSUQiPgoTQ3JlYXRlUm91dGVSZXNwb25zZRInCgVyb3V0ZRgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlIoMBChJVcGRhdGVSb3V0ZVJlcXVlc3QSFQoCaWQYASABKAsyCS50eXBlcy5JRBIyCgVpbnB1dBgCIAEoCzIjLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlVXBkYXRlSW5wdXQSIgoPb3JnYW5pemF0aW9uX2lkGAMgASgLMgkudHlwZXMuSUQiPgoTVXBkYXRlUm91dGVSZXNwb25zZRInCgVyb3V0ZRgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlIooCCgpSb3V0ZUlucHV0Ei4KBnN0YXR1cxgBIAEoDjIeLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlU3RhdHVzEi4KCnJvdXRlX2RhdGUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiQKEWZhY2lsaXR5X2dyb3VwX2lkGAMgASgLMgkudHlwZXMuSUQSHAoJZHJpdmVyX2lkGAQgASgLMgkudHlwZXMuSUQSHAoJaGF1bGVyX2lkGAUgASgLMgkudHlwZXMuSUQSGwoIdHJ1Y2tfaWQYBiABKAsyCS50eXBlcy5JRBIdCgp0cmFpbGVyX2lkGAcgASgLMgkudHlwZXMuSUQikAIKEFJvdXRlVXBkYXRlSW5wdXQSLgoGc3RhdHVzGAEgASgOMh4udHJhbnNwb3J0YXRpb24udjEuUm91dGVTdGF0dXMSLgoKcm91dGVfZGF0ZRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASJAoRZmFjaWxpdHlfZ3JvdXBfaWQYAyABKAsyCS50eXBlcy5JRBIcCglkcml2ZXJfaWQYBCABKAsyCS50eXBlcy5JRBIcCgloYXVsZXJfaWQYBSABKAsyCS50eXBlcy5JRBIbCgh0cnVja19pZBgGIAEoCzIJLnR5cGVzLklEEh0KCnRyYWlsZXJfaWQYByABKAsyCS50eXBlcy5JRCJyChZUcmFuc2l0aW9uUm91dGVSZXF1ZXN0EhUKAmlkGAEgASgLMgkudHlwZXMuSUQSDgoGc3RhdHVzGAIgASgJEg0KBW5vdGVzGAMgASgJEiIKD29yZ2FuaXphdGlvbl9pZBgEIAEoCzIJLnR5cGVzLklEIkMKF1RyYW5zaXRpb25Sb3V0ZVJlc3BvbnNlEigKBnJlc3VsdBgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlIv0BChJBc3NpZ25Sb3V0ZVJlcXVlc3QSFQoCaWQYASABKAsyCS50eXBlcy5JRBIZChFhc3NpZ25tZW50X3N0YXR1cxgCIAEoCRIcCglkcml2ZXJfaWQYAyABKAsyCS50eXBlcy5JRBIcCgloYXVsZXJfaWQYBCABKAsyCS50eXBlcy5JRBIbCgh0cnVja19pZBgFIAEoCzIJLnR5cGVzLklEEh0KCnRyYWlsZXJfaWQYBiABKAsyCS50eXBlcy5JRBIZChFlc3RpbWF0ZWRfYXJyaXZhbBgHIAEoCRIiCg9vcmdhbml6YXRpb25faWQYCCABKAsyCS50eXBlcy5JRCI/ChNBc3NpZ25Sb3V0ZVJlc3BvbnNlEigKBnJlc3VsdBgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlIlEKFFVuYXNzaWduUm91dGVSZXF1ZXN0EhUKAmlkGAEgASgLMgkudHlwZXMuSUQSIgoPb3JnYW5pemF0aW9uX2lkGAIgASgLMgkudHlwZXMuSUQiQQoVVW5hc3NpZ25Sb3V0ZVJlc3BvbnNlEigKBnJlc3VsdBgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlIngKFkFkZFNlcnZpY2VSb3V0ZVJlcXVlc3QSGwoIcm91dGVfaWQYASABKAsyCS50eXBlcy5JRBIdCgpzZXJ2aWNlX2lkGAIgASgLMgkudHlwZXMuSUQSIgoPb3JnYW5pemF0aW9uX2lkGAMgASgLMgkudHlwZXMuSUQiQwoXQWRkU2VydmljZVJvdXRlUmVzcG9uc2USKAoGcmVzdWx0GAEgASgLMhgudHJhbnNwb3J0YXRpb24udjEuUm91dGUiewoZUmVtb3ZlU2VydmljZVJvdXRlUmVxdWVzdBIbCghyb3V0ZV9pZBgBIAEoCzIJLnR5cGVzLklEEh0KCnNlcnZpY2VfaWQYAiABKAsyCS50eXBlcy5JRBIiCg9vcmdhbml6YXRpb25faWQYAyABKAsyCS50eXBlcy5JRCJGChpSZW1vdmVTZXJ2aWNlUm91dGVSZXNwb25zZRIoCgZyZXN1bHQYASABKAsyGC50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZSrjAQoLUm91dGVTdGF0dXMSHAoYUk9VVEVfU1RBVFVTX1VOU1BFQ0lGSUVEEAASGAoUUk9VVEVfU1RBVFVTX1BMQU5ORUQQARIXChNST1VURV9TVEFUVVNfQUNUSVZFEAISHAoYUk9VVEVfU1RBVFVTX0lOX1BST0dSRVNTEAMSGgoWUk9VVEVfU1RBVFVTX0NPTVBMRVRFRBAEEhcKE1JPVVRFX1NUQVRVU19GQUlMRUQQBRIXChNST1VURV9TVEFUVVNfVk9JREVEEAYSFwoTUk9VVEVfU1RBVFVTX1BBVVNFRBAHKrEDCg9Sb3V0ZVNvcnRPcHRpb24SIQodUk9VVEVfU09SVF9PUFRJT05fVU5TUEVDSUZJRUQQABIgChxST1VURV9TT1JUX09QVElPTl9TVEFUVVNfQVNDEAESIQodUk9VVEVfU09SVF9PUFRJT05fU1RBVFVTX0RFU0MQAhIkCiBST1VURV9TT1JUX09QVElPTl9TVEFSVEVEX0FUX0FTQxADEiUKIVJPVVRFX1NPUlRfT1BUSU9OX1NUQVJURURfQVRfREVTQxAEEiYKIlJPVVRFX1NPUlRfT1BUSU9OX0NPTVBMRVRFRF9BVF9BU0MQBRInCiNST1VURV9TT1JUX09QVElPTl9DT01QTEVURURfQVRfREVTQxAGEiQKIFJPVVRFX1NPUlRfT1BUSU9OX0NSRUFURURfQVRfQVNDEAcSJQohUk9VVEVfU09SVF9PUFRJT05fQ1JFQVRFRF9BVF9ERVNDEAgSJAogUk9VVEVfU09SVF9PUFRJT05fVVBEQVRFRF9BVF9BU0MQCRIlCiFST1VURV9TT1JUX09QVElPTl9VUERBVEVEX0FUX0RFU0MQCjLFAQoTUm91dGVRdWVyaWVzU2VydmljZRJTCghHZXRSb3V0ZRIiLnRyYW5zcG9ydGF0aW9uLnYxLkdldFJvdXRlUmVxdWVzdBojLnRyYW5zcG9ydGF0aW9uLnYxLkdldFJvdXRlUmVzcG9uc2USWQoKTGlzdFJvdXRlcxIkLnRyYW5zcG9ydGF0aW9uLnYxLkxpc3RSb3V0ZXNSZXF1ZXN0GiUudHJhbnNwb3J0YXRpb24udjEuTGlzdFJvdXRlc1Jlc3BvbnNlMtsFChRSb3V0ZUNvbW1hbmRzU2VydmljZRJcCgtDcmVhdGVSb3V0ZRIlLnRyYW5zcG9ydGF0aW9uLnYxLkNyZWF0ZVJvdXRlUmVxdWVzdBomLnRyYW5zcG9ydGF0aW9uLnYxLkNyZWF0ZVJvdXRlUmVzcG9uc2USXAoLVXBkYXRlUm91dGUSJS50cmFuc3BvcnRhdGlvbi52MS5VcGRhdGVSb3V0ZVJlcXVlc3QaJi50cmFuc3BvcnRhdGlvbi52MS5VcGRhdGVSb3V0ZVJlc3BvbnNlEmgKD1RyYW5zaXRpb25Sb3V0ZRIpLnRyYW5zcG9ydGF0aW9uLnYxLlRyYW5zaXRpb25Sb3V0ZVJlcXVlc3QaKi50cmFuc3BvcnRhdGlvbi52MS5UcmFuc2l0aW9uUm91dGVSZXNwb25zZRJcCgtBc3NpZ25Sb3V0ZRIlLnRyYW5zcG9ydGF0aW9uLnYxLkFzc2lnblJvdXRlUmVxdWVzdBomLnRyYW5zcG9ydGF0aW9uLnYxLkFzc2lnblJvdXRlUmVzcG9uc2USYgoNVW5hc3NpZ25Sb3V0ZRInLnRyYW5zcG9ydGF0aW9uLnYxLlVuYXNzaWduUm91dGVSZXF1ZXN0GigudHJhbnNwb3J0YXRpb24udjEuVW5hc3NpZ25Sb3V0ZVJlc3BvbnNlEmgKD0FkZFNlcnZpY2VSb3V0ZRIpLnRyYW5zcG9ydGF0aW9uLnYxLkFkZFNlcnZpY2VSb3V0ZVJlcXVlc3QaKi50cmFuc3BvcnRhdGlvbi52MS5BZGRTZXJ2aWNlUm91dGVSZXNwb25zZRJxChJSZW1vdmVTZXJ2aWNlUm91dGUSLC50cmFuc3BvcnRhdGlvbi52MS5SZW1vdmVTZXJ2aWNlUm91dGVSZXF1ZXN0Gi0udHJhbnNwb3J0YXRpb24udjEuUmVtb3ZlU2VydmljZVJvdXRlUmVzcG9uc2VCQVo/cGFja2FnZXMvYmFja2VuZC1tb2R1bGUtdHJhbnNwb3J0YXRpb24vYXBpL3YxO3RyYW5zcG9ydGF0aW9uX3YxYghlZGl0aW9uc3DoBw", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_types]);

/**
 * Route message definition
 *
 * @generated from message transportation.v1.Route
 */
export type Route = Message<"transportation.v1.Route"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string document_number = 2;
   */
  documentNumber: string;

  /**
   * @generated from field: transportation.v1.RouteStatus status = 3;
   */
  status: RouteStatus;

  /**
   * @generated from field: string assignment_status = 4;
   */
  assignmentStatus: string;

  /**
   * @generated from field: string driver_progress = 5;
   */
  driverProgress: string;

  /**
   * @generated from field: string hauler_progress = 6;
   */
  haulerProgress: string;

  /**
   * @generated from field: string rank = 7;
   */
  rank: string;

  /**
   * @generated from field: int32 priority = 8;
   */
  priority: number;

  /**
   * @generated from field: google.protobuf.Timestamp route_date = 9;
   */
  routeDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 10;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 11;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: string description = 12;
   */
  description: string;

  /**
   * @generated from field: string notes = 13;
   */
  notes: string;

  /**
   * @generated from field: types.ID facility_group_id = 14;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: types.ID driver_id = 15;
   */
  driverId?: ID;

  /**
   * @generated from field: types.ID hauler_id = 16;
   */
  haulerId?: ID;

  /**
   * @generated from field: types.ID truck_id = 17;
   */
  truckId?: ID;

  /**
   * @generated from field: types.ID trailer_id = 18;
   */
  trailerId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp assigned_at = 19;
   */
  assignedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp estimated_arrival = 20;
   */
  estimatedArrival?: Timestamp;

  /**
   * @generated from field: types.Base base = 21;
   */
  base?: Base;
};

/**
 * Describes the message transportation.v1.Route.
 * Use `create(RouteSchema)` to create a new message.
 */
export const RouteSchema: GenMessage<Route> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 0);

/**
 * RouteLeg - custom type
 *
 * @generated from message transportation.v1.RouteLeg
 */
export type RouteLeg = Message<"transportation.v1.RouteLeg"> & {
  /**
   * @generated from field: string start = 1;
   */
  start: string;

  /**
   * @generated from field: string end = 2;
   */
  end: string;

  /**
   * @generated from field: double distance = 3;
   */
  distance: number;

  /**
   * @generated from field: int32 duration = 4;
   */
  duration: number;
};

/**
 * Describes the message transportation.v1.RouteLeg.
 * Use `create(RouteLegSchema)` to create a new message.
 */
export const RouteLegSchema: GenMessage<RouteLeg> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 1);

/**
 * RouteTransitionInput - custom input type
 *
 * @generated from message transportation.v1.RouteTransitionInput
 */
export type RouteTransitionInput = Message<"transportation.v1.RouteTransitionInput"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;
};

/**
 * Describes the message transportation.v1.RouteTransitionInput.
 * Use `create(RouteTransitionInputSchema)` to create a new message.
 */
export const RouteTransitionInputSchema: GenMessage<RouteTransitionInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 2);

/**
 * RouteAssignInput - custom input type
 *
 * @generated from message transportation.v1.RouteAssignInput
 */
export type RouteAssignInput = Message<"transportation.v1.RouteAssignInput"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string assignment_status = 2;
   */
  assignmentStatus: string;

  /**
   * @generated from field: string driver_id = 3;
   */
  driverId: string;

  /**
   * @generated from field: string hauler_id = 4;
   */
  haulerId: string;

  /**
   * @generated from field: string truck_id = 5;
   */
  truckId: string;

  /**
   * @generated from field: string trailer_id = 6;
   */
  trailerId: string;

  /**
   * @generated from field: string estimated_arrival = 7;
   */
  estimatedArrival: string;
};

/**
 * Describes the message transportation.v1.RouteAssignInput.
 * Use `create(RouteAssignInputSchema)` to create a new message.
 */
export const RouteAssignInputSchema: GenMessage<RouteAssignInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 3);

/**
 * Request/Response messages for Route queries
 *
 * @generated from message transportation.v1.GetRouteRequest
 */
export type GetRouteRequest = Message<"transportation.v1.GetRouteRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.GetRouteRequest.
 * Use `create(GetRouteRequestSchema)` to create a new message.
 */
export const GetRouteRequestSchema: GenMessage<GetRouteRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 4);

/**
 * @generated from message transportation.v1.GetRouteResponse
 */
export type GetRouteResponse = Message<"transportation.v1.GetRouteResponse"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;
};

/**
 * Describes the message transportation.v1.GetRouteResponse.
 * Use `create(GetRouteResponseSchema)` to create a new message.
 */
export const GetRouteResponseSchema: GenMessage<GetRouteResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 5);

/**
 * @generated from message transportation.v1.ListRoutesRequest
 */
export type ListRoutesRequest = Message<"transportation.v1.ListRoutesRequest"> & {
  /**
   * @generated from field: transportation.v1.ListRoutesFilter filter = 1;
   */
  filter?: ListRoutesFilter;

  /**
   * @generated from field: repeated transportation.v1.RouteSortOption sorting = 2;
   */
  sorting: RouteSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message transportation.v1.ListRoutesRequest.
 * Use `create(ListRoutesRequestSchema)` to create a new message.
 */
export const ListRoutesRequestSchema: GenMessage<ListRoutesRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 6);

/**
 * @generated from message transportation.v1.ListRoutesFilter
 */
export type ListRoutesFilter = Message<"transportation.v1.ListRoutesFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: transportation.v1.RouteStatus status = 2;
   */
  status: RouteStatus;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 3;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 4;
   */
  organizationId?: ID;

  /**
   * @generated from field: repeated types.ID driver_ids = 5;
   */
  driverIds: ID[];

  /**
   * @generated from field: repeated types.ID hauler_ids = 6;
   */
  haulerIds: ID[];

  /**
   * @generated from field: repeated types.ID truck_ids = 7;
   */
  truckIds: ID[];

  /**
   * @generated from field: repeated types.ID trailer_ids = 8;
   */
  trailerIds: ID[];

  /**
   * @generated from field: repeated types.ID service_ids = 9;
   */
  serviceIds: ID[];
};

/**
 * Describes the message transportation.v1.ListRoutesFilter.
 * Use `create(ListRoutesFilterSchema)` to create a new message.
 */
export const ListRoutesFilterSchema: GenMessage<ListRoutesFilter> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 7);

/**
 * @generated from message transportation.v1.ListRoutesResponse
 */
export type ListRoutesResponse = Message<"transportation.v1.ListRoutesResponse"> & {
  /**
   * @generated from field: repeated transportation.v1.Route routes = 1;
   */
  routes: Route[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message transportation.v1.ListRoutesResponse.
 * Use `create(ListRoutesResponseSchema)` to create a new message.
 */
export const ListRoutesResponseSchema: GenMessage<ListRoutesResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 8);

/**
 * Command messages
 *
 * @generated from message transportation.v1.CreateRouteRequest
 */
export type CreateRouteRequest = Message<"transportation.v1.CreateRouteRequest"> & {
  /**
   * @generated from field: transportation.v1.RouteInput input = 1;
   */
  input?: RouteInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.CreateRouteRequest.
 * Use `create(CreateRouteRequestSchema)` to create a new message.
 */
export const CreateRouteRequestSchema: GenMessage<CreateRouteRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 9);

/**
 * @generated from message transportation.v1.CreateRouteResponse
 */
export type CreateRouteResponse = Message<"transportation.v1.CreateRouteResponse"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;
};

/**
 * Describes the message transportation.v1.CreateRouteResponse.
 * Use `create(CreateRouteResponseSchema)` to create a new message.
 */
export const CreateRouteResponseSchema: GenMessage<CreateRouteResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 10);

/**
 * @generated from message transportation.v1.UpdateRouteRequest
 */
export type UpdateRouteRequest = Message<"transportation.v1.UpdateRouteRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.RouteUpdateInput input = 2;
   */
  input?: RouteUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.UpdateRouteRequest.
 * Use `create(UpdateRouteRequestSchema)` to create a new message.
 */
export const UpdateRouteRequestSchema: GenMessage<UpdateRouteRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 11);

/**
 * @generated from message transportation.v1.UpdateRouteResponse
 */
export type UpdateRouteResponse = Message<"transportation.v1.UpdateRouteResponse"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;
};

/**
 * Describes the message transportation.v1.UpdateRouteResponse.
 * Use `create(UpdateRouteResponseSchema)` to create a new message.
 */
export const UpdateRouteResponseSchema: GenMessage<UpdateRouteResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 12);

/**
 * Input messages
 *
 * @generated from message transportation.v1.RouteInput
 */
export type RouteInput = Message<"transportation.v1.RouteInput"> & {
  /**
   * @generated from field: transportation.v1.RouteStatus status = 1;
   */
  status: RouteStatus;

  /**
   * @generated from field: google.protobuf.Timestamp route_date = 2;
   */
  routeDate?: Timestamp;

  /**
   * @generated from field: types.ID facility_group_id = 3;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: types.ID driver_id = 4;
   */
  driverId?: ID;

  /**
   * @generated from field: types.ID hauler_id = 5;
   */
  haulerId?: ID;

  /**
   * @generated from field: types.ID truck_id = 6;
   */
  truckId?: ID;

  /**
   * @generated from field: types.ID trailer_id = 7;
   */
  trailerId?: ID;
};

/**
 * Describes the message transportation.v1.RouteInput.
 * Use `create(RouteInputSchema)` to create a new message.
 */
export const RouteInputSchema: GenMessage<RouteInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 13);

/**
 * @generated from message transportation.v1.RouteUpdateInput
 */
export type RouteUpdateInput = Message<"transportation.v1.RouteUpdateInput"> & {
  /**
   * @generated from field: transportation.v1.RouteStatus status = 1;
   */
  status: RouteStatus;

  /**
   * @generated from field: google.protobuf.Timestamp route_date = 2;
   */
  routeDate?: Timestamp;

  /**
   * @generated from field: types.ID facility_group_id = 3;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: types.ID driver_id = 4;
   */
  driverId?: ID;

  /**
   * @generated from field: types.ID hauler_id = 5;
   */
  haulerId?: ID;

  /**
   * @generated from field: types.ID truck_id = 6;
   */
  truckId?: ID;

  /**
   * @generated from field: types.ID trailer_id = 7;
   */
  trailerId?: ID;
};

/**
 * Describes the message transportation.v1.RouteUpdateInput.
 * Use `create(RouteUpdateInputSchema)` to create a new message.
 */
export const RouteUpdateInputSchema: GenMessage<RouteUpdateInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 14);

/**
 * TransitionRouteRequest - custom mutation request
 *
 * @generated from message transportation.v1.TransitionRouteRequest
 */
export type TransitionRouteRequest = Message<"transportation.v1.TransitionRouteRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;

  /**
   * @generated from field: types.ID organization_id = 4;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.TransitionRouteRequest.
 * Use `create(TransitionRouteRequestSchema)` to create a new message.
 */
export const TransitionRouteRequestSchema: GenMessage<TransitionRouteRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 15);

/**
 * TransitionRouteResponse - custom mutation response
 *
 * @generated from message transportation.v1.TransitionRouteResponse
 */
export type TransitionRouteResponse = Message<"transportation.v1.TransitionRouteResponse"> & {
  /**
   * @generated from field: transportation.v1.Route result = 1;
   */
  result?: Route;
};

/**
 * Describes the message transportation.v1.TransitionRouteResponse.
 * Use `create(TransitionRouteResponseSchema)` to create a new message.
 */
export const TransitionRouteResponseSchema: GenMessage<TransitionRouteResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 16);

/**
 * AssignRouteRequest - custom mutation request
 *
 * @generated from message transportation.v1.AssignRouteRequest
 */
export type AssignRouteRequest = Message<"transportation.v1.AssignRouteRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string assignment_status = 2;
   */
  assignmentStatus: string;

  /**
   * @generated from field: types.ID driver_id = 3;
   */
  driverId?: ID;

  /**
   * @generated from field: types.ID hauler_id = 4;
   */
  haulerId?: ID;

  /**
   * @generated from field: types.ID truck_id = 5;
   */
  truckId?: ID;

  /**
   * @generated from field: types.ID trailer_id = 6;
   */
  trailerId?: ID;

  /**
   * @generated from field: string estimated_arrival = 7;
   */
  estimatedArrival: string;

  /**
   * @generated from field: types.ID organization_id = 8;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.AssignRouteRequest.
 * Use `create(AssignRouteRequestSchema)` to create a new message.
 */
export const AssignRouteRequestSchema: GenMessage<AssignRouteRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 17);

/**
 * AssignRouteResponse - custom mutation response
 *
 * @generated from message transportation.v1.AssignRouteResponse
 */
export type AssignRouteResponse = Message<"transportation.v1.AssignRouteResponse"> & {
  /**
   * @generated from field: transportation.v1.Route result = 1;
   */
  result?: Route;
};

/**
 * Describes the message transportation.v1.AssignRouteResponse.
 * Use `create(AssignRouteResponseSchema)` to create a new message.
 */
export const AssignRouteResponseSchema: GenMessage<AssignRouteResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 18);

/**
 * UnassignRouteRequest - custom mutation request
 *
 * @generated from message transportation.v1.UnassignRouteRequest
 */
export type UnassignRouteRequest = Message<"transportation.v1.UnassignRouteRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.UnassignRouteRequest.
 * Use `create(UnassignRouteRequestSchema)` to create a new message.
 */
export const UnassignRouteRequestSchema: GenMessage<UnassignRouteRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 19);

/**
 * UnassignRouteResponse - custom mutation response
 *
 * @generated from message transportation.v1.UnassignRouteResponse
 */
export type UnassignRouteResponse = Message<"transportation.v1.UnassignRouteResponse"> & {
  /**
   * @generated from field: transportation.v1.Route result = 1;
   */
  result?: Route;
};

/**
 * Describes the message transportation.v1.UnassignRouteResponse.
 * Use `create(UnassignRouteResponseSchema)` to create a new message.
 */
export const UnassignRouteResponseSchema: GenMessage<UnassignRouteResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 20);

/**
 * AddServiceRouteRequest - custom mutation request
 *
 * @generated from message transportation.v1.AddServiceRouteRequest
 */
export type AddServiceRouteRequest = Message<"transportation.v1.AddServiceRouteRequest"> & {
  /**
   * @generated from field: types.ID route_id = 1;
   */
  routeId?: ID;

  /**
   * @generated from field: types.ID service_id = 2;
   */
  serviceId?: ID;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.AddServiceRouteRequest.
 * Use `create(AddServiceRouteRequestSchema)` to create a new message.
 */
export const AddServiceRouteRequestSchema: GenMessage<AddServiceRouteRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 21);

/**
 * AddServiceRouteResponse - custom mutation response
 *
 * @generated from message transportation.v1.AddServiceRouteResponse
 */
export type AddServiceRouteResponse = Message<"transportation.v1.AddServiceRouteResponse"> & {
  /**
   * @generated from field: transportation.v1.Route result = 1;
   */
  result?: Route;
};

/**
 * Describes the message transportation.v1.AddServiceRouteResponse.
 * Use `create(AddServiceRouteResponseSchema)` to create a new message.
 */
export const AddServiceRouteResponseSchema: GenMessage<AddServiceRouteResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 22);

/**
 * RemoveServiceRouteRequest - custom mutation request
 *
 * @generated from message transportation.v1.RemoveServiceRouteRequest
 */
export type RemoveServiceRouteRequest = Message<"transportation.v1.RemoveServiceRouteRequest"> & {
  /**
   * @generated from field: types.ID route_id = 1;
   */
  routeId?: ID;

  /**
   * @generated from field: types.ID service_id = 2;
   */
  serviceId?: ID;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.RemoveServiceRouteRequest.
 * Use `create(RemoveServiceRouteRequestSchema)` to create a new message.
 */
export const RemoveServiceRouteRequestSchema: GenMessage<RemoveServiceRouteRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 23);

/**
 * RemoveServiceRouteResponse - custom mutation response
 *
 * @generated from message transportation.v1.RemoveServiceRouteResponse
 */
export type RemoveServiceRouteResponse = Message<"transportation.v1.RemoveServiceRouteResponse"> & {
  /**
   * @generated from field: transportation.v1.Route result = 1;
   */
  result?: Route;
};

/**
 * Describes the message transportation.v1.RemoveServiceRouteResponse.
 * Use `create(RemoveServiceRouteResponseSchema)` to create a new message.
 */
export const RemoveServiceRouteResponseSchema: GenMessage<RemoveServiceRouteResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route, 24);

/**
 * RouteStatus enum
 *
 * @generated from enum transportation.v1.RouteStatus
 */
export enum RouteStatus {
  /**
   * @generated from enum value: ROUTE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROUTE_STATUS_PLANNED = 1;
   */
  PLANNED = 1,

  /**
   * @generated from enum value: ROUTE_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: ROUTE_STATUS_IN_PROGRESS = 3;
   */
  IN_PROGRESS = 3,

  /**
   * @generated from enum value: ROUTE_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * @generated from enum value: ROUTE_STATUS_FAILED = 5;
   */
  FAILED = 5,

  /**
   * @generated from enum value: ROUTE_STATUS_VOIDED = 6;
   */
  VOIDED = 6,

  /**
   * @generated from enum value: ROUTE_STATUS_PAUSED = 7;
   */
  PAUSED = 7,
}

/**
 * Describes the enum transportation.v1.RouteStatus.
 */
export const RouteStatusSchema: GenEnum<RouteStatus> = /*@__PURE__*/
  enumDesc(file_transportation_v1_route, 0);

/**
 * @generated from enum transportation.v1.RouteSortOption
 */
export enum RouteSortOption {
  /**
   * @generated from enum value: ROUTE_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROUTE_SORT_OPTION_STATUS_ASC = 1;
   */
  STATUS_ASC = 1,

  /**
   * @generated from enum value: ROUTE_SORT_OPTION_STATUS_DESC = 2;
   */
  STATUS_DESC = 2,

  /**
   * @generated from enum value: ROUTE_SORT_OPTION_STARTED_AT_ASC = 3;
   */
  STARTED_AT_ASC = 3,

  /**
   * @generated from enum value: ROUTE_SORT_OPTION_STARTED_AT_DESC = 4;
   */
  STARTED_AT_DESC = 4,

  /**
   * @generated from enum value: ROUTE_SORT_OPTION_COMPLETED_AT_ASC = 5;
   */
  COMPLETED_AT_ASC = 5,

  /**
   * @generated from enum value: ROUTE_SORT_OPTION_COMPLETED_AT_DESC = 6;
   */
  COMPLETED_AT_DESC = 6,

  /**
   * @generated from enum value: ROUTE_SORT_OPTION_CREATED_AT_ASC = 7;
   */
  CREATED_AT_ASC = 7,

  /**
   * @generated from enum value: ROUTE_SORT_OPTION_CREATED_AT_DESC = 8;
   */
  CREATED_AT_DESC = 8,

  /**
   * @generated from enum value: ROUTE_SORT_OPTION_UPDATED_AT_ASC = 9;
   */
  UPDATED_AT_ASC = 9,

  /**
   * @generated from enum value: ROUTE_SORT_OPTION_UPDATED_AT_DESC = 10;
   */
  UPDATED_AT_DESC = 10,
}

/**
 * Describes the enum transportation.v1.RouteSortOption.
 */
export const RouteSortOptionSchema: GenEnum<RouteSortOption> = /*@__PURE__*/
  enumDesc(file_transportation_v1_route, 1);

/**
 * Services
 *
 * @generated from service transportation.v1.RouteQueriesService
 */
export const RouteQueriesService: GenService<{
  /**
   * @generated from rpc transportation.v1.RouteQueriesService.GetRoute
   */
  getRoute: {
    methodKind: "unary";
    input: typeof GetRouteRequestSchema;
    output: typeof GetRouteResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.RouteQueriesService.ListRoutes
   */
  listRoutes: {
    methodKind: "unary";
    input: typeof ListRoutesRequestSchema;
    output: typeof ListRoutesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_route, 0);

/**
 * @generated from service transportation.v1.RouteCommandsService
 */
export const RouteCommandsService: GenService<{
  /**
   * @generated from rpc transportation.v1.RouteCommandsService.CreateRoute
   */
  createRoute: {
    methodKind: "unary";
    input: typeof CreateRouteRequestSchema;
    output: typeof CreateRouteResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.RouteCommandsService.UpdateRoute
   */
  updateRoute: {
    methodKind: "unary";
    input: typeof UpdateRouteRequestSchema;
    output: typeof UpdateRouteResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.RouteCommandsService.TransitionRoute
   */
  transitionRoute: {
    methodKind: "unary";
    input: typeof TransitionRouteRequestSchema;
    output: typeof TransitionRouteResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.RouteCommandsService.AssignRoute
   */
  assignRoute: {
    methodKind: "unary";
    input: typeof AssignRouteRequestSchema;
    output: typeof AssignRouteResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.RouteCommandsService.UnassignRoute
   */
  unassignRoute: {
    methodKind: "unary";
    input: typeof UnassignRouteRequestSchema;
    output: typeof UnassignRouteResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.RouteCommandsService.AddServiceRoute
   */
  addServiceRoute: {
    methodKind: "unary";
    input: typeof AddServiceRouteRequestSchema;
    output: typeof AddServiceRouteResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.RouteCommandsService.RemoveServiceRoute
   */
  removeServiceRoute: {
    methodKind: "unary";
    input: typeof RemoveServiceRouteRequestSchema;
    output: typeof RemoveServiceRouteResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_route, 1);

